import * as yup from 'yup'

export const SignInValidationScheme = yup.object().shape({
  email: yup.string().email('Email Address is invalid').max(100).required('The field is required'),
  password: yup.string().required('The field is required').min(8, 'Password requires minimum 8 characters')
})
